import avatar from '../../img/avatar.svg';
import Image from '../single/Image';
import ReviewText from '../single/ReviewText';
import Rating from '../single/Rating';
import Time from '../single/Time';

const Toastify = ({ review, attributes }) => {
    const { isProfileImg, isDescription, isTime, isRatting, showText } = attributes;
    const { name, photoUrl, time, ratingIcon, reviewText } = review;

    return (
        <div className='grbb-notification'>
            <Image isProfileImg={isProfileImg} url={photoUrl || avatar} name={name} />
            <div className="text">
                <ReviewText showText={showText} isDescription={isDescription} review_text={reviewText} />
                <Rating isRatting={isRatting} stars={ratingIcon} />
                <Time isTime={isTime} time={time} />
            </div>
        </div>
    )
}
export default Toastify;
